var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/images/download/251208.png")}}),_c('div',{staticClass:"btn",on:{"click":_vm.bindToDownload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }